import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloClassPayRateLookup, KiloClassPayRateLookupUpdate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateClassPayRateLookup(): UseMutationResult<
  AxiosResponse<KiloClassPayRateLookup>,
  AxiosError<ErrorMessage>,
  KiloClassPayRateLookupUpdate
> {
  const queryClient = useQueryClient();

  const updateClassPayRateLookup = (
    payload: KiloClassPayRateLookupUpdate,
  ): Promise<AxiosResponse<KiloClassPayRateLookup>> => {
    return client.put(`kilo-class-pay-rate-lookups/${payload?.kiloClassPayRateLookupId}/`, payload);
  };

  return useMutation(updateClassPayRateLookup, {
    onSuccess: () => {
      queryClient.invalidateQueries(['classPayRateLookups']);
    },
  });
}
